// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// Assets
import './../scss/OHSBarGauge.scss';


// COMPONENT
export default function OHSBarGauge (props) {
   // States and Variables
   var width = Math.round((props.current / props.max) * 100);
   
   // Functions
   const determineThreshold = function () {
      if (props.threshold) {
         if (width < 75) {
            return "ohsbargauge-threshold-safe";
         } else if ((width >= 75) && (width < 90)) {
            return "ohsbargauge-threshold-warning";
         } else if (width >= 90) {
            return "ohsbargauge-threshold-danger";
         }
      } else {
         return null;
      }
   }

   // Component
   return (
      <div id={props.id} className='ohsbargauge'>
         <div className='ohsbargauge-outer'>
            <div className={`ohsbargauge-inner ${determineThreshold()}`} style={{width: `${props.percentage ? props.percentage : width ? width : 0}%`}}>
               <p>{props.percentage ? props.percentage : width ? width : 0}%</p>
            </div>
         </div>
      </div>
   );
}